<template>
  <b-modal
      id="1"
      :title="title"
      v-model="isOpenLocal"
      size="lg"
      scrollable
      :hide-footer="hideFooter"
      :ok-title="capitalize($t('validate'))"
      :cancel-title="capitalize($t('cancel'))"
      @hide="tryCloseWorkFloModal"
      @hidden="handleCancel"
      @ok="handleOk"
  >
    <validation-observer
        ref="observerRef"
        #default="{handleSubmit, errors}"
    >
      <b-form @submit.prevent="handleSubmit(submitValidatedWorkFloLocal)">
        <form-work-flo
            :work-flo="workFloLocal"
            :work-flo-modal-default-tab="workFloModalDefaultTab"
            :formErrors="errors"
        />
        <button
            ref="submitWorkFloFormRef"
            class="d-none"
        ></button>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { ValidationObserver }   from 'vee-validate'
import { capitalize }           from '../../utils/filter'

import useAPI      from '../../utils/useAPI'
import FormWorkFlo from '../form/workFlo/WorkFlo.vue'
import { clone }   from '../../utils/utils'

export default {
  components: {
    ValidationObserver,
    FormWorkFlo
  },
  props: {
    workFlo: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    },
    workFloModalDefaultTab: {
      type: String,
      default :null
    }
  },
  setup (props, { emit }) {
    // ------------------------------------------------
    // Data
    // ------------------------------------------------
    const isOpenLocal = ref(false)
    const workFloLocal = ref(props.workFlo)
    const submitWorkFloFormRef = ref(null)
    const observerRef = ref(null)

    // ------------------------------------------------
    // Computed
    // ------------------------------------------------
    const { currentBreakPoint } = useAPI()

    const hideFooter = computed(() => {
      return !['xs', 'sm'].includes(currentBreakPoint.value)
    })

    // ------------------------------------------------
    // Watch
    // ------------------------------------------------
    watch(isOpenLocal, (val) => {
      emit('update:isOpen', val)
    })
    watch(workFloLocal, (val) => {
      emit('update:workFlo', val)
    })

    // ------------------------------------------------
    // Methods
    // ------------------------------------------------
    const tryCloseWorkFloModal = (modalEvent) => {
      if (modalEvent.trigger == 'backdrop') {
        // Click outside
        modalEvent.preventDefault()
        submitWorkFloFormRef.value.click()
      }
    }

    const submitValidatedWorkFloLocal = () => {
      emit('submitValidated')
    }

    const handleOk = async (bvModalEvent) => {
      bvModalEvent.preventDefault()

      const isValid = await observerRef.value.validate()
      if (isValid) {
        submitValidatedWorkFloLocal()
      }
    }

    const handleCancel = () => {}

    // ------------------------------------------------
    // Mounted
    // ------------------------------------------------

    // ------------------------------------------------
    // Setup
    // ------------------------------------------------
    return {
      // Components
      capitalize,

      // Data
      isOpenLocal,
      workFloLocal,
      submitWorkFloFormRef,
      observerRef,

      // Computed
      hideFooter,

      // Methods
      tryCloseWorkFloModal,
      submitValidatedWorkFloLocal,
      handleOk,
      handleCancel,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {
    workFlo: function (val) {
      this.workFloLocal = val
    },
    isOpen: function (val) {
      this.isOpenLocal = val
    }
  },
  methods: {},
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">

</style>